export default __webpack_public_path__ + "static/N0030-b482ac845d0ff300efcbb22d28381ebc.png";